import React from 'react'
import { useParams } from 'react-router-dom'

const IndustryPage = () => {
  const { industry } = useParams()

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">
        {industry?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} Invoice Template
      </h1>
      <p className="text-gray-600">Industry-specific content will be implemented in Phase 3</p>
    </div>
  )
}

export default IndustryPage
